<template>
	<div id="body-container">

		<navbar :class="{active:'bg-dark'}"/>
		<div class="SessionPopup">
			<SessionPopup />
		</div>
		<div class="overlay" :class="{ active: 'isOverlayActive' }" v-if="isSessionPopupVisible == true"></div> <!-- Overlay here -->
		<div class="flex bg-dark" @click="closeApps()">
			<div :class="{ 'w-40': isTogglingData, 'w-10': !isTogglingData,active:'bg-dark-blue'}" class="z-50">
				<sidemenubar />
			</div>
			<div class="content mt-12 flex-1 w-full h-screen overflow-y-scroll" :class="{ toggledstate: isTogglingData }">
				<div :class="controlMappingScreen == true ? 'page1':'page'">
					<slot />
				</div>
				<Footer />
			</div>
		</div>
	</div>
</template>
<style  scoped>
.page {
	margin-bottom: 80px;
}
.page1 {
    margin-bottom: 60px;
}
.SessionPopup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
  z-index: 999999; /* Ensure it's above other content */
}
.bg-dark.active {
  /* background-color:rgba(8, 8, 8, 0.5); */
  opacity:0.7;
  z-index:50;
}
.bg-dark-blue.active{
	/* background-color:rgba(0, 0, 0, 0.5); */
	opacity: 0.7;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* Black with opacity */
  z-index: 9999;
  display: none; /* Initially hidden */
}

.overlay.active {
  display: block; /* Show the overlay when active */
}
</style>
 <script lang="ts">
import navbar from '@/components/navbar.vue';
import sidemenubar from '@/components/sidemenubar.vue';
import Footer from '@/components/footer.vue';
import { defineComponent } from 'vue';
import { emitter } from '../main';
import {mapGetters} from 'vuex';
import SessionPopup from '@/components/sessionpopup.vue';

export default defineComponent({
	components: {
		navbar,
		sidemenubar,
		Footer,
		SessionPopup
	},
	data() {
		return {
			isTogglingData: true,
			appsVisible:false,
			controlMappingScreen:false,
			isSessionPopupVisible:false

		};
	},
	
	computed:{
		...mapGetters({ selectedOptionName: 'val',toggleState:'toggle' })
	},
	methods:{
		closeApps(){
		this.appsVisible=false;
		emitter.emit('apps', this.appsVisible);
		},
	},

	mounted() {
		this.isTogglingData = this.toggleState;
		emitter.on('toggle-sidebar', (isToggle: any) => {
			this.isTogglingData = isToggle;
		});
		emitter.off('isvisible');
		emitter.on('isvisible',(data:any)=>{
			this.isSessionPopupVisible = data;

		})
		if((this.$route.path.includes('/onBoardSystemInformation'))||(this.$route.path.includes('/onBoardActivitiesInfo'))||(this.$route.path.includes('/edit'))){
            this.controlMappingScreen = true
        } else {
            this.controlMappingScreen = false
        }
	},
	created() {
		emitter.off('sessionPopupVisible');
		emitter.on('sessionPopupVisible',(data:any)=>{
		this.isSessionPopupVisible = data;			
		})

		emitter.on('isvisible',(data:any)=>{						
		this.isSessionPopupVisible = data;	
				
		})
	}
});
</script>